(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-text-carousel"] && !Shopify.designMode) return;
  try {
    
  // Handle dynamic field visibility for image source selection
  document.addEventListener('DOMContentLoaded', function () {
    handleImageSourceFields();
    initEmblaCarousels();
  });

  // Listen for theme editor changes
  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.classList.contains('image-text-carousel-section')) {
        handleImageSourceFields();
        initEmblaCarousels();
      }
    });
  }

  function handleImageSourceFields() {
    const blocks = document.querySelectorAll('[data-block-type="item"]');
    blocks.forEach(function (block) {
      const imageSourceSelect = block.querySelector('select[name*="image_source"]');
      const imagePickerField = block.querySelector('.field--image_picker');
      const metaFieldInput = block.querySelector('input[name*="image_meta_field"]');
      const metaFieldTypeSelect = block.querySelector('select[name*="meta_field_type"]');

      if (imageSourceSelect) {
        const toggleFields = function () {
          const selectedValue = imageSourceSelect.value;
          if (imagePickerField) {
            imagePickerField.style.display = selectedValue === 'image_picker' ? 'block' : 'none';
          }
          if (metaFieldInput && metaFieldInput.closest('.field')) {
            metaFieldInput.closest('.field').style.display = selectedValue === 'meta_field' ? 'block' : 'none';
          }
          if (metaFieldTypeSelect && metaFieldTypeSelect.closest('.field')) {
            metaFieldTypeSelect.closest('.field').style.display = selectedValue === 'meta_field' ? 'block' : 'none';
          }
        };

        imageSourceSelect.addEventListener('change', toggleFields);
        toggleFields(); // Initial state
      }
    });
  }

  function initEmblaCarousels() {
    function setup(slider) {
      const prev = slider.querySelector('.swiper-button-prev');
      const next = slider.querySelector('.swiper-button-next');
      const onInit = function () {
        updateButtons();
      };
      const updateButtons = function () {
        if (!window._embla || !window._embla.has(slider)) return;
        const api = window._embla.get(slider);
        const atStart = !api.canScrollPrev();
        const atEnd = !api.canScrollNext();
        const noOverflow = api.scrollSnapList().length <= 1;
        if (prev) prev.classList.toggle('swiper-button-disabled', atStart || noOverflow);
        if (next) next.classList.toggle('swiper-button-disabled', atEnd || noOverflow);
      };

      const start = function () {
        const api = EmblaCarousel(slider, {
          align: 'start',
          loop: false,
          dragFree: false,
          containScroll: 'trimSnaps',
          slidesToScroll: 1,
          inViewThreshold: 0.6,
          duration: 20,
        });
        if (!window._embla) {
          window._embla = new Map();
        }
        window._embla.set(slider, api);
        api.on('init', onInit);
        api.on('select', updateButtons);
        api.on('reInit', updateButtons);
        updateButtons();
        if (prev) prev.onclick = () => api.scrollPrev();
        if (next) next.onclick = () => api.scrollNext();
      };

      if (window.EmblaCarousel === undefined && !document.getElementById('embla-lib')) {
        const s = document.createElement('script');
        s.id = 'embla-lib';
        s.src = 'https://cdn.jsdelivr.net/npm/embla-carousel@8.0.0/embla-carousel.umd.js';
        s.onload = start;
        document.head.appendChild(s);
      } else if (window.EmblaCarousel === undefined) {
        // script requested but not yet loaded
        document.getElementById('embla-lib').addEventListener('load', start);
      } else {
        start();
      }
    }

    const sliders = document.querySelectorAll('.image-text-carousel__slider');
    sliders.forEach(setup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["research"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const counters = document.querySelectorAll('.ksm-research__stat-number');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);

      const el = entry.target;
      const target = parseInt(el.dataset.target, 10);
      const duration = 1800;
      const stepTime = 16;
      const steps = duration / stepTime;
      const increment = target / steps;
      let current = 0;

        const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
            el.textContent = target + '+';
            clearInterval(timer);
        } else {
            el.textContent = Math.floor(current) + '+';
        }
        }, stepTime);
        });
  }, { threshold: 0.3 });

  counters.forEach(el => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();
})();
